const creditNotesReducer = (state = { list : [], selected: false }, action) => {
  switch (action.type) {
    case "GET_CREDIT_NOTE_LIST_SUCCESS":
      return { ...state, list: action.payload }
    case "GET_CREDIT_NOTE_DETAILS_SUCCESS":
      return { ...state, selected: action.payload }
    default:
      return state
  }
}

export default creditNotesReducer